import React from 'react';
import propTypes from 'prop-types';
import { cn } from 'lib/utils';
import style from './CollapsibleList.module.scss';
import { Link } from 'react-router-dom';
import Button from 'tailwind-components/Button/Button';
import DropDownMenu from 'components/DropDownMenu/DropDownMenu';
import { MoreVertical } from 'lucide-react';
import DropDownMenuItem from 'components/DropDownMenu/DropDownMenuItem/DropDownMenuItem';

const CollapsibleItem = ({
  title,
  options,
  optionsArray,
  listItemProps = {},
  titleAnchorProps = {}
}) => {
  const { className: listItemClassName, ...restListItemProps } = listItemProps;
  return (
    <li className={cn(style.item, listItemClassName)} {...restListItemProps}>
      <div {...titleAnchorProps}>{title}</div>
      <div className={style.options}>
        <div className={style.optionsLg}>
          {optionsArray ? (
            optionsArray.map((option, index) => (
              <Link
                key={'option_' + index}
                to={option.to}
                replace
                onClick={option.onClick}
              >
                <Button
                  variant='transparent'
                  size='xsmall'
                  rounded={'large'}
                  text={option.text}
                  outlined
                  icon={option.icon}
                />
              </Link>
            ))
          ) : (
            <div>{options}</div>
          )}
        </div>
        {optionsArray && (
          <div className={style.optionsSm}>
            <DropDownMenu
              title='Options'
              menuTrigger={
                <div title='Options'>
                  <Button
                    size='medium'
                    variant='transparent'
                    outlined
                    icon={<MoreVertical size={24} />}
                  />
                </div>
              }
            >
              {optionsArray.map((option, index) => (
                <DropDownMenuItem
                  key={'option_item_' + index}
                  text={option.text}
                  icon={option.icon}
                  to={option.to}
                  onClick={option.onClick}
                />
              ))}
            </DropDownMenu>
          </div>
        )}
      </div>
    </li>
  );
};

CollapsibleItem.propTypes = {
  title: propTypes.string,
  options: propTypes.element,
  optionsArray: propTypes.array,
  isOnlyOne: propTypes.bool,
  listItemProps: propTypes.object,
  titleAnchorProps: propTypes.object
};

export default CollapsibleItem;
